import { Environment } from './environment.model';

export const environment: Environment = {
    production: false,
    API_URL: 'https://api.arap.qc.ap.alight.com',
    redirectURL: 'https://arap.qc.ap.alight.com',
    externalCognitoTokenURL: "https://arap-qc-ext.auth.us-east-1.amazoncognito.com/oauth2/token",
    internalCognitoTokenURL: "https://arap-qc-int.auth.us-east-1.amazoncognito.com/oauth2/token",
    internalCognitoAuthorizeURL: "https://arap-qc-int.auth.us-east-1.amazoncognito.com/oauth2/authorize",
    sso_external_client_id: 'a8ghqo393ss8j3h8lm07kuf1q',
    sso_internal_client_id: '2g3ok8653qoehodtuni373m2bp',
    sso_api_pwd: '',
    identityPoolId: "us-east-1:d16d9f41-99bc-4e17-a0ec-52bbfa289149",
    showAIButton: true,
    chatEnabled: true,
    chatClientCodes: [],
    chatAllowedUserIdSubstrings: [],
    endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
    rumApplicationId: 'f57b3d31-0d60-4354-82c6-3cd0241120e6',
    websocketUrl: 'wss://wss.arap.qc.ap.alight.com',
    useApiMock: false,
    quicksightEmbedBaseUrl: "https://us-east-1.quicksight.aws.amazon.com/embed/",
    brandingApiUrl: 'https://api-qc.ap.alight.com/api/channel/foundationwidgets/worklifebranding/public',
};
